import React from 'react';
import {connect} from "react-redux";

import PaymentMethodIngenicoDailog from "./PaymentMethodIngenicoDailog.jsx";
import PaymentMethodDialog from "./PaymentMethodDialog.jsx";
import PaymentMethodChoiceDialog from './PaymentMethodChoiceDialog.jsx';
import SepaPaymentDialog from './SepaPaymentDialog.jsx';
import IngenicoPaymentDialog from './IngenicoPaymentDialog.jsx';

import {togglePMChoiceWindow, toggleNewSepaWindow, openIngenico} from "./../../actions/PaymentActions";
@connect(store => {
	return {
		paymentMethodStatus : store.payment.paymentMethodStatus || {},
		messages: store.messages.messages || []
	}})

	export default class PaymentMethod extends React.Component {

	renderIngenico = (customerAccount) => {
		const encodedURL = encodeURIComponent(`${window.location.origin}${INGENECOLOADER}`);
		const args = `&ca=${customerAccount.code}&returnUrl=${encodedURL}`;
		this.props.dispatch(openIngenico(args));
	}

	// Choose new payment method
	handleChangePM = (event) => {
		const { dispatch } = this.props;
		event && event.preventDefault();
		// open Sepa windwow instead of giving choice to user between sepa & ingenico
		dispatch(toggleNewSepaWindow(true))
		// dispatch(togglePMChoiceWindow(true))
	};

		render() {
			const {paymentMethodStatus = {}, messages = []} = this.props;
			const {openPMChoicesDialog = false, openNewSepaWindow = false, openNewIngenicoWindow = false} = paymentMethodStatus;

			return (
				<div class="text-center">
					<button className="btn btn-theme-default" onClick={this.handleChangePM}>{messages["common.label.update.paymentMethod"]}</button>
					{
						openPMChoicesDialog &&
						<PaymentMethodChoiceDialog/>
					}
					{
						openNewSepaWindow &&
						<SepaPaymentDialog/>
					}
					{
						openNewIngenicoWindow &&
						<IngenicoPaymentDialog/>
					}

				</div>
			);
		}
	}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/PaymentMethod.jsx